import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-040d9fa1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "terminal-solution-fourth-block-wrap" }
const _hoisted_2 = { class: "terminal-solution-fourth-block" }
const _hoisted_3 = { class: "terminal-solution-fourth-block-text margin-l-r second-title" }
const _hoisted_4 = { class: "terminal-solution-fourth-block-text margin-l-r second" }

import {TerminalSolutionInteractiveBlock} from "@/features";
import {onBeforeMount, ref} from "vue";
import {contract, HelpModel, location, protection, rating, useLocalizationStore} from "@/shared";


export default /*#__PURE__*/_defineComponent({
  __name: 'terminal-solution-content-third-block',
  setup(__props) {

const {translate} = useLocalizationStore();

onBeforeMount(() => {
  initArrData();
});

const arrData = ref<Array<HelpModel>>(new Array<HelpModel>());
const initArrData = () => {
  arrData.value.push(new HelpModel({
    Text: "fast_loan_approval",
    Image: contract,
  }));
  arrData.value.push(new HelpModel({
    Text: "convenient_location",
    Image: location,
  }));
  arrData.value.push(new HelpModel({
    Text: "secure_transactions",
    Image: protection,
  }));
  arrData.value.push(new HelpModel({
    Text: "online_verification",
    Image: rating,
  }));
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(translate)("cryptomat_terminal")), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(translate)("cryptomat_terminal_allows")), 1),
      _createVNode(_unref(TerminalSolutionInteractiveBlock), { class: "terminal-solution-fourth-block-interactive-block" })
    ])
  ]))
}
}

})